/* eslint-disable no-use-before-define */
import React from 'react'
import { getState, arrayFrom, Status, ajax, evalJson, toCamel, fmt} from '../twd/twd'
import { fixParams } from './fix-params'

export const Context = React.createContext()

export const TODAY = () => fmt.mdy(new Date())

const Last = getState('orders.last', {
    ts: 0,
    showFilters: true,
    filters: {
        tradeSubmitDateRangeMin: TODAY(),
        tradeSubmitDateRangeMax: TODAY(),
    },
})

export const ContextProvider = ({ _ts=0, backFrom, children } = {}) => {

    const [ts, setTs_] = React.useState(Last.value.ts || Date.now())
    const setTs = React.useCallback((a) => {
        Last.set({ts:a})
        setTs_(a)
    }, [])

    const [accounts, setAccounts_] = React.useState(Last.value.accounts || [])
    const setAccounts = React.useCallback((accounts, isReset) => {
        Last.set({accounts})
        setAccounts_(accounts)

        if (isReset) return
        setMode('search')
    }, [])

    const [accountsRef, setAccountsRef] = React.useState(null)

    const [filters, setFilters_] = React.useState(Last.value.filters || {})
    const setFilters = React.useCallback((filters, isReset) => {
        Last.set({filters})
        setFilters_(filters)

        if (isReset) return
        setMode('search')
    }, [])


    const [showFilters, setShowFilters_] = React.useState(Last.value.showFilters)
    const setShowFilters = React.useCallback((showFilters) => {
        Last.set({showFilters});
        setShowFilters_(showFilters)
    }, [])

    const [rows, setRows_] = React.useState(Last.value.rows || [])
    const setRows = React.useCallback((rows) => {
        Last.set({rows})
        setRows_(rows)
    }, [])

    const [shown, setShown_] = React.useState(Last.value.shown || {})
    const setShown = React.useCallback((shown) => {
        Last.set({shown})
        setShown_(shown)
    }, [])

    const [count, setCount_] = React.useState(Last.value.count || 0)
    const setCount = React.useCallback((count) => {
        Last.set({count})
        setCount_(count)
    }, [])

    const [page, setPage_] = React.useState(Last.value.page || 1)
    const setPage = React.useCallback((page) => {
        Last.set({page})
        setPage_(page)
    }, [])

    const [status, setStatus] = React.useState(Status.LOADING)
    const [mode, setMode] = React.useState(null)


    React.useEffect(() => {
        const m = !backFrom && _ts > Last.value.ts ? 'reset'
            : backFrom && _ts <= Last.value.ts ? 'redraw'
            : backFrom && _ts > Last.value.ts ? 'reload'
            : 'search'
        setMode(m)
    }, [])



    const onLoadMore = () => {
        setPage(page + 1)
        setMode('load-more')
    }

    React.useEffect(() => {
        switch(mode){
            case "search":
                setShown({})
                setRows([])
                setCount(0)
                setPage(1)
                doSearch()
                break
            case "load-more":
                doSearch()
                break
            case "reset":
                setShown({})
                setRows([])
                setCount(0)
                setPage(1)
                setFilters({
                    tradeSubmitDateRangeMin: TODAY(),
                    tradeSubmitDateRangeMax: TODAY(),
                }, true)
                setAccounts([], true)
                doSearch()
                break
            case "reload":
                setRows([])
                setCount(0)
                doSearch()
                break
            case "redraw":
                setStatus(Status.LOADED)
                break
            default:
                break

        }
    }, [mode])



    const doSearch = async () => {
        setStatus(Status.LOADING)

        try {
            const isReload = mode==='reload'
            const p = fixParams(
                accounts,
                filters,
                isReload ? 1 : page,
                isReload ? page * PAGESIZE : PAGESIZE,
            )

            const {data} = await ajax({
                url: '/esb/portfolio/trades',
                method: 'POST',
                params: p
            })

            let a = await data
            if (arrayFrom(a.rows).length===0) {
                a.resultSetCount = 0
            }

            const isLoadMore = mode==='load-more'
            a.rows = arrayFrom(a.rows)
                .map((r,i) => processTradeRecord(r,i))
            a.rows = (isLoadMore ? Last.value.rows || [] : []).concat(a.rows)


            setRows(a.rows)
            if (p.pageNumber===1) {
                setCount(a.resultSetCount)
            }
            setStatus(Status.LOADED)
            setMode(null)
        } catch(e) {
            setStatus(Status.FAILED_TO_LOAD)
            setMode('error')
        }

        setTs(Date.now())
    }

    return (
    <Context.Provider value={{
        Last,
        ts, setTs,
        accounts, setAccounts,
        accountsRef, setAccountsRef,
        filters, setFilters,
        showFilters, setShowFilters,

        status, setStatus,
        rows, setRows,
        shown, setShown,
        count, setCount,
        page, setPage,
        onLoadMore,
    }}>
    {children}
    </Context.Provider>
    )
}


const ACTIONS = ['action', 'buy', 'limitbuy', 'sell', 'limitsell']

const processTradeRecord = (rec) => {

    rec.tradeExecStatus = arrayFrom(rec.execList)
        .map((a, i) => ({...a, index:i, actionIndex:Math.max(ACTIONS.indexOf(a.action), 0)}))
        .sort((a,b) => {
            const d = b.actionIndex - a.actionIndex
            return d === 0 ? a.index - b.index : d
        })

    return rec
}

export const useOrders = () => React.useContext(Context)

export const getAccounts = () => arrayFrom(global.app.config.accounts)
    .filter(Boolean)

export const allAccounts = () => getAccounts().map(a => a.acctNo).sort()

export const PAGESIZE = 50

export const parseDetail = (txt) => {
    const d = evalJson(txt, {orderDetails:[]}).orderDetails[0]
    if (!d) return

    arrayFrom(d.AccountList)
    .concat(arrayFrom(d.OrderList))
    .concat(arrayFrom(d.PriceList))
    .forEach(({label, value, order}) => {
        const v  = value || order
        const n = toCamel(String(label).trim())
        if (n in d) return
        d[n] = v
    })

    return d
}



// WEBPACK FOOTER //
// ./src/orders/use-orders.js